const cookieConstants = {
  ACCEPTED: 'ACCEPTED',
};

export default cookieConstants;
